import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import logo from '../images/logo.svg'
import $ from 'jquery'
import '../layouts/index.css'
import { track_click }  from '../components/tracking'

const Header = ({ siteTitle, Pages }) => {
  let _Pages = []
  for (let ip = 0; ip < Pages.length; ip++) {
    let _page1 = Pages[ip];
    if(_page1.node.context != undefined && _page1.node.context.node != null)
    {
      _Pages.push(_page1);
    }
    
  }
  _Pages.sort((a,b) => {return a.node.context.node.index - b.node.context.node.index } );

  let _index = 0;
  
  function cerrarMenu(e){
    track_click("LaOtraCaraCerrarIndice");
    e.preventDefault();
    $('.menu_desplegado').fadeOut();
    $('.contenedor_la_otra_cara').css('background', 'initial');
    $('.contiene_header').css('position', 'initial').css('background','rgba(0, 0, 0, .5)')
  }

  function abrirMenu(e){
    track_click("LaOtraCaraIndice");
    e.preventDefault();
   $('.menu_desplegado').fadeIn();
   $('.contenedor_la_otra_cara').css('background', 'rgba(0,0,0, .2)')
   $('.contiene_header').css('position', 'sticky').css('top','0').css('background','rgba(0, 0, 0, 1)')
   
  }

  
return(
  <div className="contiene_header"
    style={{
      background: 'rgba(0, 0, 0, .5)' ,
      height: '65px',
      borderBottom: '1px solid #4A4A4A',
      zIndex:'1'
    
    }}
  >

    <div
      style={{
        margin: '0 auto',
        lineHeight: '65px',
        textAlign: 'center',
        height: '65px'
      }}
    >

    <div className="menu_texto" onClick={abrirMenu}><span>ÍNDICE</span></div>
    <div className="menu_desplegado">
      <div className="volver" onClick={cerrarMenu}>
        <span className="cerrar" >X</span>
      </div>
      <ul>
        {
           _Pages.map(({ node }, index) => {
            if((node.path != '/internal/' && node.path != 'dev-404-page/' && node.path != '/404/' && node.path != '/404.html' && node.path != '/dev-404-page/' && node.path != '/')
            && (node.context.node.type != "video"))
            {
              _index++;
                return (
                <li key={index} className="li_capitulo">
                    {/* <a href={this.props.location.pathname.replace('index.html', '') + node.path.substring(1) }> */}
                    <a href={ node.path.substring(1) }>
                      <div>{ node.context.node.label }</div>
                      <div>{node.context.node.title}</div>
                    </a>
                </li>
              )
            }
           })
        }
      </ul>
    </div>
      <a href="//www.univision.com/deportes">
        <div className="logo_univision"></div>
      </a>
      <span className="slash">/ </span>
      <h1 className="titulo_despliegue">
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
        >
          {siteTitle}

        </Link>
        La otra cara del Mundial de Rusia
      </h1>
    </div>
  </div>
  )
}

export default Header




// WEBPACK FOOTER //
// ./src/components/header.js